import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import { Sidebar } from './Sidebar';

export function MainLayout() {
  const token = useAuthStore((s) => s.token);
  if (!token) return <Navigate to="/login" replace />;
  return (
    <div id="app-shell" className="app-shell">
      <Sidebar />
      <main id="app-main" className="main">
        <Outlet />
      </main>
    </div>
  );
}
